import configdata from "../../config.json";
import { leafWareHouseSliceAction } from "./LeafWareHouseSlice";
import { getApi } from "../BaseApi";
import { getOnlyValueFromSelectObject } from "../UseAbleFun";
import { appLevelSliceActions } from "../AppLevelApi/AppLevelSlice";
export const getAllLeafWareHouseItems = () => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/leaf-ware-houses`
    );
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(
      leafWareHouseSliceAction.getAllLeafWareHouse(res.data.leafWareHouse)
    );
  };
};
export const createLeafWareHouseItem = (data) => {
  return async (dispatch) => {
    const { form } = getOnlyValueFromSelectObject(data);
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/leaf-ware-houses/store`,
      form
    );
    if (res?.error) {
      if (res?.erroType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: res.message, isError: true })
        );
      } else {
        dispatch(
          leafWareHouseSliceAction.setErrorData({
            message: res.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      leafWareHouseSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(leafWareHouseSliceAction.setInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(getAllLeafWareHouseItems());
  };
};
export const getDataForEdit = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/leaf-ware-houses/edit/${id}`
    );

    const data = { ...res.data.leafWareHouse[0] };
    dispatch(appLevelSliceActions.setLoadingState());
    data.status = {
      value: `${data.status}`,
      label: data.status === "active" ? "Active" : "Deactive",
      type: "status",
    };
    dispatch(leafWareHouseSliceAction.getLeafWareHouseDataEdit(data));
  };
};

export const updateLeafWareHouseItem = (data) => {
  const { form } = getOnlyValueFromSelectObject(data);
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const resData = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/leaf-ware-houses/update/${data.id}`,
      form
    );
    if (resData?.error) {
      if (resData?.errorType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: resData.message, isError: true })
        );
      } else {
        dispatch(
          leafWareHouseSliceAction.setErrorData({
            message: resData.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      leafWareHouseSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(leafWareHouseSliceAction.setInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(getAllLeafWareHouseItems());
  };
};

export const deleteLeafWareHouseItem = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    await getApi(
      "get",
      `${configdata.SERVER_URL}/api/leaf-ware-houses/delete/${id}`
    );
    dispatch(appLevelSliceActions.setLoadingState());
  };
};
